/**
 * AI CONTEXT: architecture - React entrypoint and global styles
 * 
 * Purpose:
 * - Mount React app with StrictMode
 * - Load global stylesheet
 * - Provide single root for SPA
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 